export const INFORMATION = {
  company_name: "주식회사 디벨로세티",
  found_date: "2005년 8월 3일",
  CEO: "이상용",
  capital: "500,000,000원",
  address: "서울 강남구 테헤란로 439, 10층(삼성동, 연당빌딩)",
  phone_number: "TEL: (02) 6203-6000",
  fax: "FAX: (02) 6203-6003",
  business_number: "220-86-56140",
  major: "부동산 개발"
}

export const GREETINGS = {
    summary: "다양한 실무를 바탕으로 축적된 경험과 전문 노하우를 갖춘 전문가들로 구성된 맨파워",
    detail: "고객의 입장에서 생각하는 고객의 needs에 대한 충분한 고민, 분명한 개발 concept 설정과 디자인 감각과 설계, 철저한 분석, 입체적 전략수입, 프로젝트 관리와 수행이라는 단어로 개발회사를 표현합니다. 그러나 저희 디벨로시티는 여기에 만족하지 않고 어려운 투자개발 사업시장에서도 배우며, 한걸음씩 이루어 보여주고, 진정한 가치발견과 최고 가치를 제공하는데 열정을 가진 도전 그리고 행복 나눔의 비젼을 이루어가는 기억으로 자리매김할 수 있도록 노력하겠습니다. \n\n성원해 주신 고객과 믿음으로 함께한 파트너, 미래가치를 제공할 고객에게 심심한 감사를 드립니다. 앞으로도 도시를 발전시키고 고객과 행복을 나누는 것에 앞장 서겠습니다. \n\n감사합니다.",
    author: { position: "(주)디벨로시티 대표이사", name: "이상용" }
}

export const VISION = [
    { title: "Dreams of Development",
      content: "당신이 상상하고 꿈을 꾼다면, 꿈은 실현하는 자의 몫입니다. \n꿈이 현실이 되고 미래가 되는 길은 노력과 신념일 것입니다. \n최고의 꿈을 꾸는 곳. 그리고 그 최고의 꿈을 실현하는 순간에 디벨로시티가 당신 옆에 있습니다." },
    { title: "Discover the Real Value",
      content: "진정한 가치를 발견하고 싶다면, 가치는 만들어지는 것이 아니라 만들어가는 것입니다. \n능동과 긍정의 힘. 그것이 진정한 가치를 찾는 당신의 선택이라면 미래가치의 진정한 발견은 곧 시작되고 있습니다." },
    { title: "Development Ever Up City",
      content: "당신의 꿈을 실현하는 기업. 당신의 진정한 가치에 함께하는 기업. \n그것이 도시를 발전시키고 고객과 행복을 나누는 것, 디벨로시티의 비전입니다." }
]

export const TIMELINE = [
    { year: 2020, event: ["힐스테이트 천호역젠트리스 분양", "㈜정주시에스시 주택건설업 등록"] },
    { year: 2019, event: ["방이동 어반로프트 분양"] },
    { year: 2018, event: ["㈜어반로프트 설립"] },
    { year: 2010, event: ["서울숲 한라시그마벨리 분양"] },
    { year: 2008, event: ["부동산 개발업 전문업체 등록"] },
    { year: 2007, event: ["Anaheim Oriental Festival Project 사업개시"] },
    { year: 2005, event: ["법인상호변경(주식회사 디벨로시티)"] },
    { year: 2003, event: ["주식회사 돔과희망 법인설립 / 이상용 대표이사 취임"] }    
]
